/**
 * Nome do produto, em um lugar só.
 *
 * Estava escrito em quatro arquivos e, quando mudou de "Gestão de Ações" para "Gestão de
 * Backlog", cada um teve de ser encontrado à mão. Uma constante evita a próxima rodada
 * disso e impede a tela mostrar um nome e a aba do navegador mostrar outro.
 *
 * O título da aba fica em `index.html` e não pode importar daqui: é o único lugar que
 * repete o nome, de propósito, porque precisa existir antes de o JavaScript carregar.
 */
export const NOME_DO_PRODUTO = 'Gestão de Backlog';
